import { render, staticRenderFns } from "./contactPersonDialog.vue?vue&type=template&id=3da2d366&"
import script from "./contactPersonDialog.vue?vue&type=script&lang=js&"
export * from "./contactPersonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports